div#apc-react-root
    .spinner